import React from 'react';
import { styles } from './styles';
import { withStyles, StyledComponentProps, Typography } from '@material-ui/core';
import { MenuContacts } from '../../ui-components/Icons';

const contacts = (props: StyledComponentProps) => {
    return (<div className={props.classes.root}>
        <MenuContacts  className={props.classes.subHeaderIcon}/>
        <Typography className={props.classes.title} variant='h6'>Contatti</Typography>
    </div>)
}

export const Contacts = withStyles(styles)(contacts)